// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-quiz .czt-quiz__question__side__image{position:relative;display:inline-block;width:100%}.czt-quiz .czt-quiz__question__headline{padding-bottom:0;padding-top:1rem}.czt-quiz .czt-quiz__question__answer--relevant{color:#fff !important}.czt-quiz .czt-quiz__question__answer__subtitle{font-size:0.875rem}", ""]);
// Exports
module.exports = exports;
